import { Outlet, Navigate } from "react-router-dom";

import { UseAuthentication } from "../../services/authentication/authentication.context";

export const ProtectedRoutes = () => {

    const { isAuthenticated } = UseAuthentication();

    return (
        isAuthenticated === false ? <Navigate to={"/signin"} /> : <Outlet />
    )
}